import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-radio-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  template: `
    <div class="field-wrapper" [class]="field.cssClass" [class.has-error]="isInvalid">

      <label>{{ field.label }}<a *ngIf="hasLabelLink" [href]="field.linkUrl" [target]="field.linkTarget ?? '_blank'" [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null">{{ field.linkText }}</a></label>

      <div class="radio-group">
        <label
          *ngFor="let opt of field.options"
          class="radio-option">
          <input
            type="radio"
            [name]="field.id"
            [value]="opt.value"
            [formControl]="control"
            [disabled]="opt.disabled ?? false" />
          <span>{{ opt.label }}</span>
        </label>
      </div>

      <small *ngIf="field.hint && !isInvalid && !isPending"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>

      <span *ngIf="isPending" class="field-pending">
        Verificando...
      </span>

      <small *ngIf="isInvalid" class="error">
        {{ errorMessage }}
      </small>

    </div>
  `,
  styles: [`
    .radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      margin-top: 0.25rem;
    }
    .radio-option {
      display: inline-flex;
      align-items: center;
      gap: 0.4rem;
      cursor: pointer;
      font-size: 0.9rem;
    }
    .radio-option input[type="radio"] {
      accent-color: currentColor;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
    }
    .radio-option input[type="radio"]:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `]
})
export class RadioFieldComponent extends BaseFieldComponent {}
